import { v4 as uuidv4 } from "uuid";
/**
 * Generate a string for use as a GUID
 *
 * This is currently a 36 hex-character GUID with traditional 8-4-4-4-12 dashed-grouped formatting, for example,
 * "1b9d6bcd-bbfd-4b2d-9b5d-ab8dfbbd4bed" (i.e. it's a v4 UUID, generated from a CSPRNG)
 */
export function guid() {
    return uuidv4();
}
/**
 * Regex that also matches technically malformed UUIDs (version/variant field invalid)
 *
 * @see https://github.com/uuidjs/uuid/blob/main/src/regex.js
 */
const looseRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
/**
 * Tests whether a given string is a valid GUID
 */
export function isGuid(value) {
    return looseRegex.test(value);
}
//# sourceMappingURL=guid.js.map